export const TYPES = {
  OPEN_DRAWER: "OPEN_DRAWER",
  CLOSE_DRAWER: "CLOSE_DRAWER",
};

export function openDrawer() {
  return async (dispatch) => {
    dispatch({type: TYPES.OPEN_DRAWER});
  };
}

export function closeDrawer() {
  return async (dispatch) => {
    dispatch({ type: TYPES.CLOSE_DRAWER });
  };
}
